import { render, staticRenderFns } from "./MerchantCard.vue?vue&type=template&id=e448bc04&scoped=true"
import script from "./MerchantCard.vue?vue&type=script&lang=js"
export * from "./MerchantCard.vue?vue&type=script&lang=js"
import style0 from "./MerchantCard.vue?vue&type=style&index=0&id=e448bc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e448bc04",
  null
  
)

export default component.exports